import { motion } from 'framer-motion'
import './ThumbsRating.css'

export default function ThumbsRating({ value, onChange }) {
  return (
    <div className="thumbs-rating">
      <motion.button
        type="button"
        className={`thumb-button ${value === true ? 'selected thumbs-up' : ''}`}
        onClick={() => onChange(true)}
        whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.1 }}
      >
        <span className="thumb-icon">👍</span>
        <span className="thumb-label">Thumbs Up</span>
      </motion.button>

      <motion.button
        type="button"
        className={`thumb-button ${value === false ? 'selected thumbs-down' : ''}`}
        onClick={() => onChange(false)}
        whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.1 }}
      >
        <span className="thumb-icon">👎</span>
        <span className="thumb-label">Thumbs Down</span>
      </motion.button>
    </div>
  )
}
